<template>
  <div class="col-3-center">
    <p>Auch die jungen Stadtbewohner konnten ihre Wünsche am Bürger-Workshop in der betreuten ­Kinder-Stadt-Station einbringen. Sie konnten ihre Stadt mitgestalten, Bilder malen und kreativ sein.</p>
    <p>
      <strong>WARUM BETEILIGT DIE STADT DACHAU DIE KINDER?</strong>
      <a
        target="_blank"
        href="https://www.forschungsinformationssystem.de/servlet/is/196873/"
      >(Externer Link zur Webseite des Forschungsinformationssystems</a>)
    </p>
    <p>»Kinder und Jugendliche haben einen rechtlichen Anspruch auf eine ­menschenwürdige, gesunde Entwicklung und damit das Recht auf entsprechende Lebensbedingungen. Neben dem Schutz und der Versorgung von Kindern und Jugendlichen sind ausdrücklich deren gleichberechtigte Teilhabe an der Gesellschaft und ihre Beteiligung am politischen Prozess zu nennen. Neben internationalen Regelungen wie dem UN-Kinderkonvention-Übereinkommen über die Rechte des Kindes, der AGENDA 21 der Vereinten Nationen und der «Revidierten Europäischen Charta der Beteiligung der Jugend am Leben der Gemeinde und der Region« gilt auf nationaler Ebene das Kinder- und ­Jugendhilfegesetz (KJHG) (Sozialgesetzbuch) [SGB VIII], das in entsprechenden Ausführungsgesetzen auf Landesebene zu konkretisieren ist.</p>
    <p>Die Beteiligung von Kindern und Jugendlichen bei Themen wie ­Stadtentwicklung, Bauleitplanung, Verkehrsgestaltung oder Umweltfragen hebt auch der »Nationale Aktionsplan für ein kindergerechtes Deutschland, 2005-2010” als zukunftsweisendes Handlungsfeld hervor. Darüber hinaus ist die ­Beteiligung von Kindern und Jugendlichen in einigen Bundesländern in den Gemeindeordnungen verankert. Dies verpflichtet die Kommunen dazu, Kinder und Jugendliche bei Planungen und Vorhaben, die ihre Interessen berühren, in angemessener Weise zu beteiligen. Geeignete Verfahren sind zu entwickeln und durchzuführen.«</p>IDEEN UND WÜNSCHE DER KINDER
    <p>Die Einträge auf dem Kinderstadt-Plakat und der Malvorlage:</p>
    <p>
      // Eisladen
      <br />// Weniger Müll
      <br />// Eine Kletteranlage
      <br />// Weniger Autos
      <br />// Weniger Häuser (Haus als Zeichnung)
      <br />// Es soll Kinder-Parteien geben
      <br />// Einen Pferdestall mit Ponys und Pferden
      <br />// Ich möchte, dass es weniger Autos gibt
      <br />// Tiergehege z.B. für Rehe
      <br />// Ich will, dass das Eisstadion nicht abgerissen wird?
      <br />// Pferde sollen in der Stadt frei herumlaufen können
      <br />// Weniger Handys außer Telefone. Mehr Fahrradwege
      <br />// Trampolin Halle
      <br />// Ein Gestüt
      <br />// Geld fürs Tierheim
      <br />// Eine Töpferwerkstatt. Mehr Wald, keine Strom-Roller.
      <br />// Mehr für Fledermäuse
      <br />// Mehr Bäume
      <br />// Matschplatz -> Idee von Marie
      <br />// Mehr Spielplätze
      <br />// Mehr Rechte für Kinder
      <br />// Weniger Idioten
      <br />// Sichere Gehwege und sichere Fahrradwege (Sara Lilienthal)
      <br />// Autos sollen besser auf Ampeln achten (Sara)
      <br />// Kinder ab 10 Jahren sollen wählen können
      <br />// Vorfahrt für Kinder (Spielstraßen in »Familienvierteln«) (Johann)
      <br />// Mehr Fahrräder, weniger Autos, mehr Solaranlagen und Windräder und mehr Wasserräder, die Strom erzeugen. Mehr Hitzefrei!
      <br />
      <br />
    </p>
    <div>
      <Gallery :items="items" />
    </div>
  </div>
</template>

<script>
import Gallery from "@/components/Gallery.vue";
import Timeline from "@/components/Timeline.vue";

import Anmeldung from "@/components/MachMit/Anmeldung.vue";

export default {
  components: {
    Anmeldung,
    Gallery,
    Timeline
  },
  data() {
    return {
      items: [
        {
          src: require("@/assets/fotos/kinderstadt/img1.jpg")
        },
        {
          src: require("@/assets/fotos/kinderstadt/img2.jpg")
        },
        {
          src: require("@/assets/fotos/kinderstadt/img3.jpg")
        },
        {
          src: require("@/assets/fotos/kinderstadt/img4.jpg")
        }
      ]
    };
  },
  methods: {
    showForm() {}
  }
};
</script>
<style scoped lang="scss">
section {
  height: 100%;
}
</style>
